import { MenuItemOption } from "@components/common/mobile/mobile-types";
import { GroupTypes } from "@custom-types/group-types";
import { SelectionIcon } from "@flat-ui";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { selectedRowIdsSelector } from "@store/table/table-selector";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { toggleItemSelection } from "@utils/array-utils";

/**
 * Hook to get the menu options for mobile view of groups.
 * @returns An array of menu item options for groups.
 */
export function useGroupMenuOptionsMobile(): MenuItemOption<GroupTypes>[] {
  const dispatch = useAppDispatch();
  const selectedRowIds = useAppSelector(selectedRowIdsSelector);

  const menuOptions: MenuItemOption<GroupTypes>[] = [
    {
      label: "Select group",
      Icon: SelectionIcon,
      onSelect: (group) => {
        const newSelectedRowIds = toggleItemSelection(selectedRowIds, group.id);
        dispatch(setInitialFetchingItems(newSelectedRowIds));
      },
    },
  ];

  return menuOptions;
}
